import { render, staticRenderFns } from "./CheckerboardConfirmDesign.vue?vue&type=template&id=30f4d07b"
import script from "./CheckerboardConfirmDesign.vue?vue&type=script&lang=js"
export * from "./CheckerboardConfirmDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports